import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';

const CredibilitySection = () => {
  const credentials = [
    { text: "Founder of AI CoLab Studio", icon: FiIcons.FiActivity },
    { text: "Founder and CEO of M-prez Enterprise", icon: FiIcons.FiTarget },
    { text: "Author of 'Start AI Right for Nonprofits'", icon: FiIcons.FiBookOpen },
    { text: "Fellow of the Royal Society of Arts (RSA)", icon: FiIcons.FiAward },
    { text: "15+ years experience in social impact, arts and culture", icon: FiIcons.FiCalendar },
    { text: "Experienced programme designer and facilitator", icon: FiIcons.FiUsers },
    { text: "Practical AI implementation specialist", icon: FiIcons.FiCpu }
  ];

  return (
    <div className="bg-white p-8 md:p-12 rounded-[2.5rem] shadow-sm border border-gray-100">
      <h2 className="text-2xl font-bold text-brand-navy mb-8">Why organisations trust my approach</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {credentials.map((item, i) => (
          <motion.div 
            key={i}
            initial={{ opacity: 0, x: -10 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.05 }}
            viewport={{ once: true }}
            className="flex items-center gap-4 p-4 rounded-2xl bg-brand-cream/50 border border-brand-cream"
          >
            <div className="w-10 h-10 bg-brand-teal/10 rounded-xl flex items-center justify-center text-brand-teal shrink-0">
              <SafeIcon icon={item.icon} className="w-5 h-5" />
            </div>
            <span className="font-bold text-brand-navy text-sm leading-tight">{item.text}</span>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CredibilitySection;